<template>
  <div class="headerCart delayed-display hstack h-100">
    <a href="/cart"
        class="cart-icon cart-buy-icon d-flex position-relative"
        data-cktag="Cart Icon"
        data-dd-action-name="View Cart (Header)"
        :aria-label="`Buyers cart${cartCount > 0 ? ' ' + cartCount + ' items in cart' : ''}`">
      <span class="cart-icon-text text-white fs-6 pe-1 align-self-center d-none d-lg-block">BUY</span>
      <div class="icon-placeholder">
        <img src="/local/images/fontawesome/cart-arrow-down-solid.svg" class="fs-2 align-self-center icon" height="24" width="27" alt="Cart Icon">
        <img src="/local/images/fontawesome/cart-arrow-down-solid-primary-light-blue.svg" class="fs-2 align-self-center icon-hover" height="24" width="27" alt="Cart Icon">
      </div>
      <span class="position-absolute translate-middle badge fs-6 rounded-2"
            v-if="cartCount > 0">{{ cartCount }}</span>
    </a>

    <a v-if="!this.is_portal" href="/sellcart" 
        class="cart-icon cart-sell-icon d-flex position-relative" 
        data-cktag="Sellcart Icon" 
        data-dd-action-name="View Sellcart (Header)"
        :aria-label="`Sellers cart${sellCartCount > 0 ? ' ' + sellCartCount + ' items in cart' : ''}`"
        >
      <span class="cart-icon-text text-white fs-6 pe-1 align-self-center d-none d-lg-block">SELL</span>
      <div class="icon-placeholder cart-icon">
        <img src="/local/images/fontawesome/cart-arrow-up-solid.svg" class="fs-2 align-self-center icon" height="24" width="27" alt="Sell Cart Icon">
        <img src="/local/images/fontawesome/cart-arrow-up-solid-primary-light-blue.svg" class="fs-2 align-self-center icon-hover" height="24" width="27" alt="Sell Cart Icon">
      </div>
      <span class="position-absolute translate-middle badge fs-6 rounded-2"
            v-if="sellCartCount > 0">{{ sellCartCount }}</span>
    </a>
  </div>
</template>

<script>
import loadData from "../utils/loadData";

export default {
  props : {
    is_portal: Number,
    default: 0
  },
  data() {
    return {
      cartCount: 0,
      sellCartCount: 0,
    };
  },
  methods: {
    initCartData() {
      let _this = this;
      let orderServiceTargetUrl = '/api/cart/countAll?v=' + (new Date().getTime()).toString(24);
      let callback = function (result) {

        _this.cartCount = result.cart_count;
        _this.sellCartCount = result.sell_cart_count;
      }
      loadData.get(orderServiceTargetUrl, callback);
    }
  },
  mounted() {
    let _this = this;
    $('.delayed-display').addClass('ready');

    const cartType = $('body').hasClass('purchasing') ? 'sell-cart' : 'buy-cart';
    this.initCartData();
    $(document).on('cartUpdated.ck', function (evt, data) {
      let cartQty = 0;
      for (let key in data.items) {
        if (typeof data.items[key].qty !== 'undefined' && data.items[key].qty > 0) {
          cartQty += parseInt(data.items[key].qty);
        }
      }
      if (cartType == 'buy-cart') {
        _this.cartCount = cartQty;
      } else {
        _this.sellCartCount = cartQty;
      }


    });
  }
};
</script>


